export default __webpack_public_path__ + "static/media/add.5f76ce9d.svg";